import React from 'react';

const Blog = () => {
  const articles = [
    {
      id: 1,
      title: "The Art of Diamond Selection: A Guide to Timeless Elegance",
      excerpt: "Discover the secrets behind choosing the perfect diamond that embodies luxury and sophistication...",
      date: "February 15, 2026",
      image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400"
    },
    {
      id: 2,
      title: "Jewelry Care: Preserving Your Precious Investments",
      excerpt: "Learn essential maintenance tips to keep your fine jewelry sparkling for generations...",
      date: "February 10, 2026",
      image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400"
    },
    {
      id: 3,
      title: "Emerging Trends in Luxury Jewelry Design",
      excerpt: "Explore the latest innovations and timeless designs shaping the future of haute joaillerie...",
      date: "February 5, 2026",
      image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <div className="luxury-container py-20">
        <h1 className="text-5xl font-bold text-center mb-4 hero-glow">JEWELRY INSIGHTS</h1>
        <p className="text-center text-gray-400 mb-16 text-lg">Discover the artistry, care, and trends behind timeless luxury</p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <article key={article.id} className="bg-gray-900/50 rounded-lg overflow-hidden border border-yellow-600/20 hover:border-yellow-500/40 transition-all duration-300 hover-glow">
              <img src={article.image} alt={article.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-3 text-yellow-400">{article.title}</h2>
                <p className="text-gray-300 mb-4">{article.excerpt}</p>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-500">{article.date}</span>
                  <button className="text-yellow-500 hover:text-yellow-400 font-medium">Read More →</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;